import axios from "axios";
import clsx from "clsx";
import { stringify } from "qs";
import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Button from "../components/common/Button";
import Title from "../components/common/Title";
import { Settings } from "../Settings";

export type OIDCCallbackPageProps = {
} & React.HTMLAttributes<HTMLDivElement>

function OIDCCallbackPage({
  className,
  ...rest
}: OIDCCallbackPageProps) {

  const [params] = useSearchParams()
  const code = params.get("code")

  const [state, next] = useState({
    loading: false,
    error: ""
  })

  useEffect(() => {
    let aborted = false

    const exchangeCode = async () => {
      const res = await axios.post(
        Settings.tokenUri,
        stringify({
          grant_type: Settings.grantType,

          client_id: Settings.app.clientId,
          // client_secret: "",

          redirect_uri: Settings.redirectUri,
          scope: Settings.scopes.join(" "),

          code,
          // code_verifier: "",
        }), {
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/x-www-form-urlencoded",
        }
      })

      if ([200, 201].includes(res.status)) {
        // local storage...
      }
    }

    exchangeCode()

    return () => { aborted = true; }
  }, [code])

  return (
    <div className={clsx(className, "flex flex-col bg-lands bg-cover  h-screen w-screen")} {...rest}>
      <div className='flex flex-col h-full justify-center items-center'>
        <div className="flex flex-col items-center justify-center w-screen h-screen bg-eternity-lands bg-cover p-4">
          <img className="max-w-container-sm lg:max-w-xl" src="/logo.webp" alt="Eternity logo" />
          <div className="flex flex-col gap-2 items-center mt-4 md:mt-24">
            <div className="flex flex-col items-center">
              <Title className="font-bold text-title-lg">OIDC Callback</Title>
            </div>
            <a href="/authorize">
              <Button size="xl">
                Return to Auth page
              </Button>
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default OIDCCallbackPage;